import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box,
  Paper,
  TextField,
  InputAdornment,
  Button,
  Modal,
  IconButton,
  Chip,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Grid,
  Tooltip
} from "@mui/material";
import { Search as SearchIcon, Edit as EditIcon } from "@mui/icons-material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import baseURL from "../../config";
import WarningIcon from '@mui/icons-material/Warning';
import TablePagination from "@mui/material/TablePagination";
import * as XLSX from "xlsx";
import { jwtDecode } from "jwt-decode";


const SignOffModal = ({ signoffDetails, onUpdate }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedSignOff, setSelectedSignOff] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [crewData, setCrewData] = useState({ name: "", indos: "" });
  const [formData, setFormData] = useState({
    date: "",
    portName: "",
    portCountry: "",
  });

  const userID = localStorage.getItem("user id");
  const [isSaving, setIsSaving] = useState(false);
  const [selectedCrewName, setSelectedCrewName] = useState({ name: "", indosno: "" });
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editingSignOffId, setEditingSignOffId] = useState(null);
  const [newSignOffDate, setNewSignOffDate] = useState("");


  const months = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleEditClick = ({ contract, name, indosno }) => {
    setSelectedSignOff(contract);
    setFormData({
      date: "",
      portName: "",
      portCountry: "",
    });
    setSelectedCrewName({ name, indosno });
    setEditModalOpen(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const token = localStorage.getItem("token");
  let userEmail = "";

  if (token) {
    try {
      const decoded = jwtDecode(token);
      userEmail = decoded.email;
    } catch (error) {
      console.error("Invalid token:", error);
    }
  }

  const ChangeSignOffDate = async (id) => {
    try {

      if (!newSignOffDate) {
        alert("Please select a SignOff date!");
        return;
      }

      const response = await axios.put(
        `${baseURL}/api/updateSignOffDateByEmail/${id}`,
        { newDate: newSignOffDate },
        { headers: { Authorization: `Bearer ${token}` } }
      );


      if (response.data.success) {
        alert("✅ SignOff Date updated successfully!");
        setEditingSignOffId(null);
        setNewSignOffDate("");
        window.location.reload();

      } else {
        console.warn("⚠️ API returned success:false");
        alert("⚠️ Failed to update COC Date.");
      }
    } catch (error) {
      console.error("❌ Error updating COC Date:", error);
      console.error("❌ Error details:", error.response?.data);
      alert(error.response?.data?.message || "Internal server error");
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getContractRemainingDays = (startDateStr, durationInMonths) => {
    if (!startDateStr || !durationInMonths) return null;

    const startDate = new Date(startDateStr);
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + parseInt(durationInMonths));

    const today = new Date();

    if (endDate <= today) return "Contract Ended";

    let remainingMonths = (endDate.getFullYear() - today.getFullYear()) * 12 +
      (endDate.getMonth() - today.getMonth());

    let adjustedEnd = new Date(today);
    adjustedEnd.setMonth(adjustedEnd.getMonth() + remainingMonths);

    // If adjustedEnd goes past the actual endDate, reduce a month
    if (adjustedEnd > endDate) {
      remainingMonths--;
      adjustedEnd.setMonth(adjustedEnd.getMonth() - 1);
    }

    // Now calculate the remaining days
    const remainingDays = Math.ceil((endDate - adjustedEnd) / (1000 * 60 * 60 * 24));

    const months = remainingMonths;
    const days = remainingDays;

    let result = [];
    if (months) result.push(`${months} month${months > 1 ? "s" : ""}`);
    if (days) result.push(`${days} day${days > 1 ? "s" : ""}`);

    return `Contract remaining : ${result.join(" ")} `;
  };

  const handleSave = async () => {

    if (!formData.date || !formData.portName.trim() || !formData.portCountry.trim()) {
      toast.error("All fields are required.");
      return;
    }


    if (!selectedSignOff) {
      toast.error("No contract selected!");
      return;
    }

    setIsSaving(true);

    const token = localStorage.getItem("token");

    const dataToSend = {
      creatorId: userID,
      crewId: selectedSignOff.contractDetails?.crewdetails?._id || "",
      contractId: selectedSignOff.contractDetails?._id || "",
      departure: [{
        date: formData.date,
        portName: formData.portName,
        country: formData.portCountry,
      }]
    };

    try {
      const response = await axios.post(`${baseURL}/api/statusAfterForm1`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });

      toast.success("Data saved successfully!");
      setEditModalOpen(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error saving data:", error.response?.data || error.message);
      toast.error("Failed to save data. Please try again.");
    } finally {
      setIsSaving(false); // Hide loader
    }
  };

  const handleOpenSignOffFiles = ({ signOffData, name, indos }) => {
    if (!signOffData) {
      console.error("Sign-On data is missing");
      return;
    }
    const documents = [];

    if (signOffData.cdcStamppageFile?.filePath) {
      documents.push({
        name: "CDC Stamp Page",
        filePath: `${baseURL}/${signOffData.cdcStamppageFile.filePath.replace(/\\/g, "/")}`,
      });
    }

    if (signOffData.passport?.filePath) {
      documents.push({
        name: "Passport",
        filePath: `${baseURL}/${signOffData.passport.filePath.replace(/\\/g, "/")}`,
      });
    }

    if (signOffData.salaryclose?.filePath) {
      documents.push({
        name: "salaryclose",
        filePath: `${baseURL}/${signOffData.salaryclose.filePath.replace(/\\/g, "/")}`,
      });
    }

    setCrewData({ name, indos })
    setSelectedDocuments(documents);
    setOpenModal(true);
  };


  const filteredSignOffDetails = Array.isArray(signoffDetails)
    ? signoffDetails.filter((contract) => {
      const vesselName = contract.contractDetails?.ShipDetails?.vesselname?.toLowerCase() || "";
      const agentName = contract.contractDetails?.crewingAgent?.agentName?.toLowerCase() || "";
      const crewName = contract.contractDetails?.crewdetails?.name?.toLowerCase() || "";
      const indos = contract.contractDetails?.crewdetails?.indosno?.toLowerCase() || "";

      return vesselName.includes(searchQuery.toLowerCase()) || agentName.includes(searchQuery.toLowerCase()) || crewName.includes(searchQuery.toLowerCase()) ||
        indos.includes(searchQuery.toLowerCase());
    })
    : [];

  // console.log("filteredContracts", filteredSignOffDetails);

  const filteredCocData = filteredSignOffDetails.filter((row) => {
    const cocDateRaw = row.contractStatusAfterForm1?.signOff?.[0]?.Date || row.contractStatusAfterForm1?.signOff?.[0]?.date;
    if (!cocDateRaw) return false;

    const cocDate = new Date(cocDateRaw);
    const month = String(cocDate.getMonth() + 1).padStart(2, '0'); // '03' for March
    const year = String(cocDate.getFullYear());

    // console.log({ month, year, selectedMonth, selectedYear, cocDateRaw });

    return (
      (!selectedMonth || month === selectedMonth) &&
      (!selectedYear || year === String(selectedYear))
    );
  });

  const getRemainingDays = (dateStr) => {
    if (!dateStr) return null;
    const cocDate = new Date(dateStr);
    const today = new Date();
    const diffTime = today - cocDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const remaining = 30 - diffDays;
    return remaining > 0 ? remaining : 0;
  };

  const handleExportToExcel = () => {
    const dataToExport = filteredCocData.map((item, index) => {
      const cocDate = item.contractStatusAfterForm1?.coc?.[0]?.Date;
      const formattedCocDate = cocDate
        ? new Date(cocDate).toLocaleDateString("en-GB")
        : "N/A";

      const signOnDate = item.contractStatusAfterForm1?.signOn?.[0]?.date;
      const formattedSignOnDate = signOnDate
        ? new Date(signOnDate).toLocaleDateString("en-GB")
        : "N/A";

      const signOffDate = item.contractStatusAfterForm1?.signOff?.[0]?.date;
      const formattedSignOffDate = signOffDate
        ? new Date(signOffDate).toLocaleDateString("en-GB")
        : "N/A";

      const duration = item.contractDetails?.contractDuration;
      const contractRemaining = getContractRemainingDays(cocDate, duration);

      const signOffPortCountry = item.contractStatusAfterForm1?.signOff?.[0]?.portCountry || "N/A";
      const signOffPortName = item.contractStatusAfterForm1?.signOff?.[0]?.portName || "N/A";

      const signOffCreator = item.contractStatusAfterForm1?.signOff?.[0]?.creatorIdWithName?.[0]?.name || "N/A";
      const signOffCreatedAt = item.contractStatusAfterForm1?.signOff?.[0]?.creatorIdWithName?.[0]?.createdAt;
      const formattedSignOffCreatedAt = signOffCreatedAt
        ? new Date(signOffCreatedAt).toLocaleDateString("en-GB").replace(/\//g, "-")
        : "N/A";

      return {
        "Sr No.": index + 1,
        "Vessel Name": item.contractDetails?.ShipDetails?.vesselname || "N/A",
        "Company": item.contractDetails?.vesselOwner?.company_shortname || "N/A",
        "Crew Name": item.contractDetails?.crewdetails?.name || "N/A",
        "Indos No.": item.contractDetails?.crewdetails?.indosno || "N/A",
        "Agent": item.contractDetails?.crewingAgent?.agentName || "N/A",
        "COC Date": formattedCocDate,
        "SignOn Date": formattedSignOnDate,
        "SignOff Date": formattedSignOffDate,
        "SignOff Port Country": signOffPortCountry,
        "SignOff Port Name": signOffPortName,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "COC_SignOff_Details");

    XLSX.writeFile(workbook, "COC_SignOff_Details.xlsx");
  };


  return (
    <Box mt={3} width="100%" p={2}>
      <Box
        sx={{
          p: 1,
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "nowrap",
          gap: 2,
        }}
      >
        {/* Search Bar */}
        <TextField
          placeholder="Search by Vessel or Agent Name"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
          }}
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            width: 280,
          }}
        />

        {/* Title */}
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ whiteSpace: "nowrap", mx: 2 }}
        >
          Sign-Off Details
        </Typography>

        {/* Filters: Month and Year */}
        <Box sx={{ display: "flex", gap: 1 }}>
          <FormControl size="small" sx={{ bgcolor: "white", borderRadius: 1, minWidth: 200 }}>
            <InputLabel>Month</InputLabel>
            <Select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              label="Month"
            >
              {months.map((m) => (
                <MenuItem key={m.value} value={m.value}>
                  {m.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ bgcolor: "white", borderRadius: 1, minWidth: 200 }}>
            <InputLabel>Year</InputLabel>
            <Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              label="Year"
            >
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            onClick={handleExportToExcel}
            variant="contained"
            sx={{
              width: 180,
              height: 40,
              backgroundColor: '#2e7d32',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1b5e20',
              },
            }}
          >
            Export to Excel
          </Button>
        </Box>

        {/* Total Count */}
        <Typography
          variant="h6"
          component="h2"
          fontWeight="500"
          sx={{ whiteSpace: "nowrap" }}
        >
          Total Count: {filteredCocData.length}
        </Typography>
      </Box>


      <Paper elevation={3} sx={{ p: 2, mt: 1 }}>
        {filteredCocData.length > 0 ? (
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Sr. No.</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Contract Details</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Documents</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>ScreenShot</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCocData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((contract, index) => {
                  const cocDate = contract.contractStatusAfterForm1?.coc?.[0]?.Date;
                  const duration = contract.contractDetails?.contractDuration;
                  const contractRemainingLabel = getContractRemainingDays(cocDate, duration);

                  return (
                    <TableRow key={index} hover>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                          <Typography variant="subtitle2" fontWeight="bold">
                            <strong style={{ color: "black" }}>
                              Vessel Name: {contract.contractDetails?.ShipDetails?.vesselname || "N/A"}
                            </strong>
                          </Typography>
                          <Typography variant="subtitle2" fontWeight="bold">
                            <strong style={{ color: "#2e7d32" }}>
                              Company Name: {contract.contractDetails?.vesselOwner?.company_shortname || "N/A"}
                            </strong>
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", marginTop: 1 }}>
                          <Chip
                            size="small"
                            label={`Crew: ${contract.contractDetails?.crewdetails?.name || "N/A"}`}
                            sx={{ bgcolor: "#e3f2fd", color: "#0d47a1" }}
                          />
                          <Chip
                            size="small"
                            label={`Indos No.: ${contract.contractDetails?.crewdetails?.indosno || "N/A"}`}
                            sx={{ bgcolor: "#fff9c4", color: "#f57f17" }}
                          />
                          <Chip
                            size="small"
                            label={`Agent: ${contract.contractDetails?.crewingAgent?.agentName || "N/A"}`}
                            sx={{ bgcolor: "#f3e5f5", color: "#6a1b9a" }}
                          />

                          <Chip
                            size="small"
                            label={`Port Country: ${contract.contractStatusAfterForm1?.signOff?.[0]?.portCountry || "N/A"}`}
                            sx={{ bgcolor: "#ede7f6", color: "#311b92" }}
                          />
                          <Chip
                            size="small"
                            label={`Port Name: ${contract.contractStatusAfterForm1?.signOff?.[0]?.portName || "N/A"}`}
                            sx={{ bgcolor: "#e3f2fd", color: "#0d47a1" }}
                          />
                          {/* <Chip
                            size="small"
                            label={`SignOff Date: ${contract.contractStatusAfterForm1?.signOff?.[0]?.date
                              ? new Date(contract.contractStatusAfterForm1.signOff[0].date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              })
                              : "N/A"
                              }`}
                            sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                          /> */}
                          {/* ✅ Show editable or view mode for COC Date */}
                          {editingSignOffId === contract?.contractStatusAfterForm1?._id &&
                            userEmail === "neeturashmi@gmail.com" ? (
                            <>
                              <TextField
                                type="date"
                                value={newSignOffDate}
                                onChange={(e) => setNewSignOffDate(e.target.value)}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                sx={{ mr: 1 }}
                              />
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => ChangeSignOffDate(contract?.contractStatusAfterForm1?._id)}
                                disabled={!newSignOffDate}
                              >
                                Save
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{ ml: 1 }}
                                onClick={() => {
                                  setEditingSignOffId(null);
                                  setNewSignOffDate("");
                                }}
                              >
                                Cancel
                              </Button>
                            </>
                          ) : (
                            <>

                              <Chip
                                size="small"
                                label={`SignOff Date: ${contract?.contractStatusAfterForm1?.signOff?.[0]?.date
                                  ? new Date(contract?.contractStatusAfterForm1.signOff[0].date)
                                    .toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    })
                                  : "N/A"
                                  }`}
                                sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                              />
                              {userEmail === "neeturashmi@gmail.com" && (
                                <Tooltip title="Edit SignOff Date">
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => {
                                      setEditingSignOffId(contract?.contractStatusAfterForm1?._id);
                                      setNewSignOffDate(
                                        contract?.contractStatusAfterForm1?.signOff?.[0]?.date
                                          ? new Date(contract.contractStatusAfterForm1.signOff[0].date)
                                            .toISOString()
                                            .split("T")[0]
                                          : ""
                                      );
                                    }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </>
                          )}


                          {contractRemainingLabel && (
                            <Chip
                              size="medium"
                              icon={
                                contractRemainingLabel === "Contract Ended" ? (
                                  <WarningIcon sx={{ color: "#b71c1c" }} />
                                ) : (
                                  <HourglassEmptyIcon sx={{ color: "#0277bd" }} />
                                )
                              }
                              label={contractRemainingLabel}
                              sx={{
                                bgcolor: contractRemainingLabel === "Contract Ended" ? "#ffebee" : "#e1f5fe",
                                color: contractRemainingLabel === "Contract Ended" ? "#b71c1c" : "#01579b",
                                fontWeight: "bold",
                                borderRadius: 2,
                                px: 2,
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                userSelect: "none",
                                minWidth: 180,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            />
                          )}

                          {/* {contract?.contractStatusAfterForm1?.signOff?.[0]?.creatorIdWithName?.[0] && (
                            <Chip
                              size="small"
                              label={`Added SignOff: ${contract.contractStatusAfterForm1.signOff[0].creatorIdWithName[0].name} - ${new Date(contract.contractStatusAfterForm1.signOff[0].creatorIdWithName[0].createdAt).toLocaleDateString('en-GB').replace(/\//g, '-')}`}
                              sx={{ bgcolor: "#ffebee", color: "#c62828" }}
                            />
                          )} */}
                          {contract?.contractStatusAfterForm1?.signOff?.[0]?.creatorIdWithName?.length > 0 && (
                            <Chip
                              size="small"
                              label={`Added SignOff: ${contract.contractStatusAfterForm1.signOff[0].creatorIdWithName[
                                contract.contractStatusAfterForm1.signOff[0].creatorIdWithName.length - 1
                              ].name
                                } - ${new Date(
                                  contract.contractStatusAfterForm1.signOff[0].creatorIdWithName[
                                    contract.contractStatusAfterForm1.signOff[0].creatorIdWithName.length - 1
                                  ].createdAt
                                )
                                  .toLocaleDateString("en-GB")
                                  .replace(/\//g, "-")}`}
                              sx={{ bgcolor: "#ffebee", color: "#c62828" }}
                            />
                          )}


                        </Box>
                      </TableCell>
                      <TableCell>
                        {contract.contractStatusAfterForm1?.signOff?.[0] && (
                          <>
                            {(contract.contractStatusAfterForm1.signOff[0].cdcStamppageFile?.filePath ||
                              contract.contractStatusAfterForm1.signOff[0].passport?.filePath ||
                              contract.contractStatusAfterForm1.signOff[0].salaryclose?.filePath) && (
                                <IconButton
                                  onClick={() =>
                                    handleOpenSignOffFiles({
                                      signOffData: contract?.contractStatusAfterForm1.signOff[0],
                                      name: contract?.contractDetails?.crewdetails?.name || "N/A",
                                      indos: contract?.contractDetails?.crewdetails?.indosno || "N/A",
                                    })
                                  }
                                >
                                  <PictureAsPdfIcon sx={{ color: "red" }} />
                                </IconButton>
                              )}
                          </>
                        )}
                      </TableCell>
                      {/* {console.log("contract", contract)} */}
                      <TableCell>
                        <IconButton color="primary"
                          onClick={() => handleEditClick({
                            contract: contract,
                            name: contract.contractDetails?.crewdetails?.name || "N/A",
                            indosno: contract.contractDetails?.crewdetails?.indosno || "N/A"
                          })
                          }>
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        {contract?.ssDocuments?.signoff?.length > 0 && (
                          <>
                            {contract.ssDocuments.signoff.map((docItem, docIndex) => (
                              <Tooltip title={docItem.ssDocument?.originalName || "SignOff Document"} key={docIndex}>
                                <IconButton
                                  onClick={() => window.open(`${baseURL}/${docItem.ssDocument?.filePath}`, "_blank")}
                                >
                                  <PictureAsPdfIcon sx={{ color: "red" }} />
                                </IconButton>
                              </Tooltip>
                            ))}
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  )
                })}
            </TableBody>

          </Table>
        ) : (
          <Typography color="textSecondary" align="center">
            No matching sign-off details found.
          </Typography>
        )}
      </Paper>

      {/* Modal for Editing Sign-Off Details */}
      <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            p: 3,
            borderRadius: 2,
            border: "none",
          }}
        >
          <Typography variant="h6" align="center" gutterBottom>
            Enter Arrival: {" "}
            {selectedCrewName && (
              <span style={{ color: "green" }}> {selectedCrewName.name} - {selectedCrewName.indosno}</span>
            )}
          </Typography>
          <TextField
            fullWidth
            required
            label="Date"
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            margin="dense"
            variant="outlined"
            inputProps={{
              max: new Date().toISOString().split("T")[0], // Restricts to past & present dates
            }}
          />
          <TextField
            fullWidth
            required
            label="Sign-Off Port Name"
            name="portName"
            value={formData.portName}
            onChange={handleChange}
            margin="dense"
            variant="outlined"
          />
          <TextField
            fullWidth
            required
            label="Sign-Off Country"
            name="portCountry"
            value={formData.portCountry}
            onChange={handleChange}
            margin="dense"
            variant="outlined"
          />
          <Box mt={2} display="flex" justifyContent="space-between">
            <Button onClick={() => setEditModalOpen(false)} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              color="primary"
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Save"}
            </Button>

          </Box>
        </Paper>
      </Modal>

      {/* Modal for documents Details */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "60%", md: "50%" },
            maxHeight: "80vh",
            bgcolor: "white",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
          >
            Sign-Off Documents - {crewData?.name} - {crewData?.indos}
          </Typography>

          {selectedDocuments.length > 0 ? (
            selectedDocuments.map((doc, index) => (
              <Paper
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  mb: 2,
                  boxShadow: 2,
                  borderRadius: 2,
                  transition: "0.3s",
                  "&:hover": { boxShadow: 4, bgcolor: "#f5f5f5" },
                }}
              >
                <Box display="flex" alignItems="center">
                  <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                  <Typography variant="body1">
                    {doc.name || "Unnamed Document"}
                  </Typography>
                </Box>

                {doc.filePath && doc.filePath.trim() !== "" ? (
                  <Button
                    variant="contained"
                    color="primary"
                    href={doc.filePath}
                    target="_blank"
                    rel="noopener noreferrer"
                    size="small"
                    sx={{ textTransform: "none" }}
                  >
                    Download
                  </Button>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No File Available
                  </Typography>
                )}
              </Paper>
            ))
          ) : (
            <Typography align="center" color="textSecondary">
              No documents available
            </Typography>
          )}

          <Box display="flex" justifyContent="center" mt={2}>
            <Button variant="contained" color="error" onClick={() => setOpenModal(false)}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      <TablePagination
        component="div"
        count={filteredSignOffDetails.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={{
          px: 2,
          bgcolor: "#fafafa",
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          justifyContent: "flex-end"
        }}
      />
      <ToastContainer />
    </Box>
  );
};

export default SignOffModal;
